// SDK для интеграции с TgAnalytics (используется для трекинга трафика с tapps_bot)
// Документация: https://docs.tganalytics.xyz/sdk/preparations

import { logErrorMini } from '../service-logger/lib/log-error-mini';

// Токен нужно получить у @DataChief_bot
const TG_ANALYTICS_TOKEN = import.meta.env.VITE_TG_ANALYTICS_TOKEN;

// Метка источника, которую нужно отслеживать для отправки аналитики
export const TAPPS_SOURCE = 'tapps_offer10';

// Имя приложения должно совпадать с тем, что указано в @DataChief_bot
export const APP_NAME = 'playdeck';

// Флаг, который показывает, был ли уже отправлен ивент app-init
let isAppInitEventSent = false;
/**
 * Инициализирует TgAnalytics SDK и отправляет событие app-init,
 * если пользователь пришел с меткой tapps_offer10 и пришел на страницу meta-game из стартап параметров
 * @param src - Метка источника перехода
 * @param path - Путь страницы
 */
export const initTgAnalyticsForTapps = async (
  src?: string | undefined
): Promise<void> => {
  // Если ивент уже был отправлен или источник не совпадает с нужным или не редирект на meta-game - выходим
  if (isAppInitEventSent || src !== TAPPS_SOURCE) {
    return;
  }

  try {
    const telegramAnalytics = await import('@telegram-apps/analytics');

    await telegramAnalytics.default.init({
      token: TG_ANALYTICS_TOKEN,
      appName: APP_NAME,
    });

    console.log('[TgAnalytics]: connected');
    isAppInitEventSent = true;
  } catch (error) {
    void logErrorMini(error as Error, 'initTgAnalyticsForTapps');
  }
};
